import { Image, Menu, Skeleton } from "antd";
import { Children, useContext, useEffect, useState } from "react";
import { NavLink } from "react-router-dom";

import Logo from "../../assets/images/sidebar-black-logo.png";
import Chat from "../../assets/images/side_nav/chat.svg";
import Cms from "../../assets/images/side_nav/cms.svg";
import Coust from "../../assets/images/side_nav/customer.svg";
import Coust1 from "../../assets/images/item.svg";
import Coust2 from "../../assets/images/side-ic1.svg";
import Coust3 from "../../assets/images/side-ic2.svg";
import Coust4 from "../../assets/images/side-ic10.svg";
import Cath from "../../assets/images/side_nav/cath.svg";

import Dash from "../../assets/images/side_nav/dash.svg";
import File from "../../assets/images/side_nav/file.svg";
import Log from "../../assets/images/side_nav/log.svg";
import Bell from "../../assets/images/side_nav/notification.svg";
import Order from "../../assets/images/side_nav/order.svg";

import DashbordIcon from "../../assets/images/dashbord-image/dashbord.png";
import NotificationIcon from "../../assets/images/notification.svg";
import AppUpdatesIcon from "../../assets/images/dashbord-image/App-Updates.png";
import ChallengeManagementIcon from "../../assets/images/dashbord-image/Challenge-Management.png";
import ContentModerationIcon from "../../assets/images/dashbord-image/Content-Moderation.png";
import LeaderboardIcon from "../../assets/images/dashbord-image/Leaderboard.png";
import ReportingManagementIcon from "../../assets/images/dashbord-image/Reporting-Management.png";
import SecurityIcon from "../../assets/images/dashbord-image/Security.png";
import StoreManagementIcon from "../../assets/images/dashbord-image/Store-Management.png";
import UserEngagementIcon from "../../assets/images/dashbord-image/User-Engagement.png";
import UserManagementIcon from "../../assets/images/dashbord-image/User-Management.png";
import VideoManagementIcon from "../../assets/images/dashbord-image/Video-Management.png";

import { AuthContext } from "../../context/AuthContext";
import DeleteModal from "../DeleteModal";
import { useAppContext } from "../../context/AppContext";
import { Severty, ShowToast } from "../../helper/toast";

export const menuItems = [
  {
    key: "dashboard-management",
    path: "/dashboard",
    icon: DashbordIcon,
    label: "Dashboard",
  },
  {
    key: "role-management",
    label: "Security and Permissions",
    icon: SecurityIcon,
    children: [
      {
        key: "role-manager",
        label: "Role Manager",
        path: "/sub-admin-role",
      },
      {
        key: "sub-admin-manager",
        label: "Sub Admin Manager",
        path: "/sub-admin",
      },
    ]
  },
  {
    key: "customer-management",
    label: "User Manager",
    icon: UserManagementIcon,
    path: "/customer",
  },
  {
    key: "subscription-management",
    label: "Subscription Manager",
    icon: StoreManagementIcon,
    path: "/subscription",
  },
  {
    key: "challenge-management",
    label: "Challenge Manager",
    icon: ChallengeManagementIcon,
    children: [
      {
        key: "challenge-manager",
        label: "Challenge Template",
        path: "/challenge",
      },
      {
        key: "user-challenge-management",
        label: "User Challenge Manager",
        path: "/user-challenge",
      },
    ]
  },
  {
    key: "content-management",
    label: "Content & Video Manager",
    icon: ContentModerationIcon,
    children: [
      {
        key: "feed-management",
        label: "Feed Manager",
        path: "/feed",
      },
      {
        key: "content-media-management",
        path: "/content-media",
        label: "Content Manager",
      },
    ]
  },
  {
    key: "leaderboard-management",
    label: "Leaderboard Manager",
    icon: LeaderboardIcon,
    path: "/leaderboard",
  },
  {
    key: "store-reward-management",
    label: "Store & Reward Manager",
    icon: StoreManagementIcon,
    children: [
      {
        key: "category-management",
        label: `Category Manager`,
        path: "/category",
      },
      {
        key: "attribute-management",
        path: "/attribute",
        label: "Attribute Manager",
      },
      {
        key: "product-management",
        path: "/product",
        label: "Product Manager",
      },
      {
        key: "coupon-management",
        path: "/coupon",
        label: "Coupon Manager",
      },
      {
        key: "order-management",
        path: "/order",
        label: "Order Manager",
      },
      {
        key: "transaction-management",
        path: "/transaction",
        label: "Transaction Manager",
      },
    ],
  },
  {
    key: "support-management",
    path: "/support",
    icon: ContentModerationIcon,
    label: "Support Manager",
  },
  {
    key: "cms-management",
    path: "/cms",
    icon: ReportingManagementIcon,
    label: "CMS Manager",
  },
  {
    key: "email-template-management",
    path: "/email-templates",
    icon: AppUpdatesIcon,
    label: "Email Template Manager",
  },
  {
    key: "notifications",
    path: "/notification",
    icon: Bell,
    label: "Notifications",
  },
];

function Sidenav({ color }) {
  const { userProfile, logout, setUserProfile } = useContext(AuthContext);
  const { country } = useAppContext();

  const [collapsed, setCollapsed] = useState(false);
  const [loading, setLoading] = useState(false);
  const [menuLinks, setMenuLinks] = useState([]);
  const [menuMode, setMenuMode] = useState("inline");

  const [isLogoutModalVisible, setIsLogoutModalVisible] = useState(false);

  const showDeleteConfirm = (record) => {
    // logout();
    setIsLogoutModalVisible(true);
  };

  const renderTitle = (item) => {
    return (
      <>
        <Image preview={false} src={item.icon} />
        <span className="label">{item.label}</span>
      </>
    );
  };

  useEffect(() => {
    setLoading(true);
    if (!userProfile) return;
    if (userProfile.type == "Admin") {
      const items = menuItems;
      setMenuLinks(items);
      setLoading(false);
      return;
    }

    const newArray = menuItems.filter((item) => {
      if (item.isShow) {
        return true;
      } else {
        return userProfile?.role_id?.permission?.includes(item.key);
      }
    });

    const links = newArray.filter((item) => {
      if (item?.children?.length) {
        return true;
      } else if (!item?.children) {
        return true;
      } else {
        return false;
      }
    });

    setMenuLinks(links);
    setLoading(false);
  }, [userProfile, country]);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 768) {
        setMenuMode("inline");
      } else {
        setMenuMode("vertical");
      }
    };

    window.addEventListener("resize", handleResize);

    handleResize();

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <>
      {loading ? (
        [1, 2, 3, 4, 5, 6].map((item) => <Skeleton active key={item} />)
      ) : (
        <>
          <div className="brand-logo">
            <NavLink to="/dashboard" className="imgOuter">
              <img className="" src={Logo} alt="" />
            </NavLink>
          </div>
          <Menu inlineCollapsed={false} mode="inline" className="sideNavMain">
            {menuLinks.map((item) => {
              if (item.children) {
                return (
                  <>
                    <Menu.SubMenu
                      className="vehicle-icon"
                      key={item.key}
                      title={
                        <>
                          <span className="icon">
                            <Image preview={false} src={item.icon} />
                          </span>
                          <span className="label">{item.label}</span>
                        </>
                      }
                    >
                      {item.children.map((child) => (
                        <Menu.Item key={child.key}>
                          <NavLink to={child.path}>
                            {renderTitle(child)}&nbsp;
                          </NavLink>
                        </Menu.Item>
                      ))}
                    </Menu.SubMenu>
                  </>
                );
              }

              return (
                <Menu.Item key={item.key} disabled={item?.comming_soon}>
                  <NavLink to={item.path}>
                    {renderTitle(item)}&nbsp;
                    {item?.comming_soon ? "(Comming Soon)" : ""}
                  </NavLink>
                </Menu.Item>
              );
            })}

            <Menu.Item onClick={showDeleteConfirm}>
              <NavLink to={"#"}>
                <>
                  <Image preview={false} src={Log} />
                  <span className="label">Logout</span>
                </>
              </NavLink>
            </Menu.Item>
          </Menu>
        </>
      )}
      {isLogoutModalVisible && (
        <DeleteModal
          title={"Logout"}
          subtitle={`Are you sure you want to logout?`}
          show={isLogoutModalVisible}
          hide={() => {
            setIsLogoutModalVisible(false);
          }}
          onOk={() => {
            ShowToast("Logout Successfully!", Severty.SUCCESS);
            logout();
          }}
        />
      )}
    </>
  );
}

export default Sidenav;
